import React, { useEffect } from 'react';
import './Manu.css';

const Manu = () => {
    useEffect(() => {
        console.log('Manu useEffect running');
        const elements = document.querySelectorAll('.animate-on-scroll');
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    console.log(`${entry.target.className} isIntersecting: ${entry.isIntersecting}`);
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate');
                    }
                });
            },
            { threshold: 0.2 }
        );

        elements.forEach((element) => {
            console.log('Observing:', element);
            observer.observe(element);
        });

        return () => {
            elements.forEach((element) => observer.unobserve(element));
        };
    }, []);

    const keyTopics = [
        {
            title: "Production Planning Process",
            description: "Planning efficient production workflows for IoT device manufacturing."
        },
        {
            title: "Component Sourcing Process",
            description: "Sourcing high-quality components for reliable IoT and embedded systems."
        },
        {
            title: "PCB Assembly Process",
            description: "Assembling PCBs with precision for optimal IoT device performance."
        },
        {
            title: "Surface-Mount Technology (SMT) Process",
            description: "Applying SMT for compact and efficient IoT PCB assembly."
        },
        {
            title: "Through-Hole Assembly Process",
            description: "Using through-hole techniques for robust IoT device connections."
        },
        {
            title: "Quality Control Process",
            description: "Implementing strict quality controls to ensure manufacturing standards."
        },
        {
            title: "Testing and Inspection Process",
            description: "Conducting thorough tests and inspections for IoT product reliability."
        },
        {
            title: "Packaging and Logistics Process",
            description: "Managing packaging and logistics for safe and timely IoT product delivery."
        },
        {
            title: "Supply Chain Management Process",
            description: "Optimizing supply chains for efficient IoT manufacturing operations."
        }
    ];

    return (
        <div className="detail-page">
            <h1 className="detail-heading animate-on-scroll" style={{ animationDelay: '0.1s' }}>
                Manufacturing
            </h1>
            <p className="detail-intro animate-on-scroll" style={{ animationDelay: '0.2s' }}>
                Our manufacturing services deliver precise, reliable, and efficient production for IoT and embedded systems, ensuring high-quality devices from assembly to delivery.
            </p>
            <h2 className="detail-subheading animate-on-scroll" style={{ animationDelay: '0.3s' }}>
                Key Topics
            </h2>
            <ul className="detail-topics">
                {keyTopics.map((topic, index) => (
                    <li
                        key={index}
                        className="topic-card animate-on-scroll"
                        style={{ animationDelay: `${0.4 + index * 0.05}s` }}
                    >
                        <strong className="topic-title">{topic.title}</strong>
                        <p className="topic-description">{topic.description}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Manu;